// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    cancelAutoDelivery as cancelAutoDeliveryService,
    CancelAutoDeliveryModel,
} from "@guestsupply/App/Services/AutoDelivery";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

export type AutoDeliveryProps = {
    productId: string;
};
type HandlerType = ApiHandler<
    CancelAutoDeliveryModel & HasOnSuccess & HasOnError<string>,
    ServiceResult<CancelAutoDeliveryModel> & {
        errorMessage?: string;
    }
>;

export const CallCancelAutoDeliveryApi: HandlerType = async props => {
    const { productId } = props.parameter;

    const cancelAutoDelivryResult = await cancelAutoDeliveryService({
        productId,
    });
    props.apiResult = cancelAutoDelivryResult;
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};
export const chain = [CallCancelAutoDeliveryApi, ExecuteOnSuccessCallback];

const cancelAutoDelivery = createHandlerChainRunner(chain, "cancelAutoDelivery");
export default cancelAutoDelivery;
